import type { TStatusOption } from "../../statuses/consts";
import type { TStatus } from "../../statuses/statusLogic";

// needed because our security headers block imgur images
// theres a redirect in the netlify toml to handle this
export function formatLogoUrl(logo: string): string {
  return logo
    .replace("https://i.imgur.com/", "/imgur-images/")
    .replace("https://25285638.fs1.hubspotusercontent-eu1.net/", "/hubspot/");
}

export const shouldShowLogo = (value: TStatus) => value !== "private" && value !== "eod";

export const tryShowFormattedLogo = (
  option: TStatusOption | undefined,
  fallbackLogo: string | undefined,
): string | undefined => {
  const logo = option?.logo ?? fallbackLogo;
  return option !== undefined && logo !== undefined && shouldShowLogo(option.value) ? formatLogoUrl(logo) : undefined;
};
